import * as React from "react";
import css from "./entry-point.module.css";

export default function EntryPoint({ index, refs, node }) {
  const ref = refs.current[index];
  const { id, metadata } = node;
  const { x, y } = metadata;
  return (
    <div
      ref={ref}
      id={id}
      className={css.entryPoint}
      style={{ left: x, top: y }}
    >
      <span
        data-connector-anchor=""
        dangerouslySetInnerHTML={{ __html: node.name }}
      />
    </div>
  );
}
